import React from 'react';


const Header: React.FC = () => {
    return (
        <div></div>
    );
};

export default Header;